var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.card},[_c('div',{class:_vm.$style.title},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.count)?_c('div',{class:_vm.$style.count},[_vm._v(" "+_vm._s(_vm.count)+" ")]):_vm._e()]),_c('div',{class:_vm.$style.body},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }